import { Component, OnInit, OnChanges, Input, ViewChild, TemplateRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/take';
import { ToasterService } from 'angular2-toaster';
import { ReportsService } from '../../../services/index';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Store } from '@ngrx/store';
import * as fromCommonStore from '../../../store';

@Component({
    selector: 'phone-tracking-followup-change-tab',
    templateUrl: './phoneTrackingFollowupChange.component.html'
})
export class PhoneTrackingFollowupChangeComponent implements OnInit, OnChanges {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;

    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;

    isLoadMask: Promise<any>;
    loadingIndicator = true;
    suppressPaging = false;
    scrollTimeout: any;

    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: '',
        orderDir: 'desc'
    };

    filterData: any = {
        from_date: new Date(),
        to_date: new Date(),
        branch_id: '',
        search_name: ''
    };

    reportData: any[] = [];
    columns: any[] = [];
    usertype: string = '';
    initialized = false;

    branchList: any[] = [];
    branchCtrl: FormControl;
    filteredBranch: Observable<any[]>;

    constructor(
        private reportsService: ReportsService,
        private toasterService: ToasterService,
        private store: Store<any>
    ) {}

    ngOnInit() {
        let that = this;
        this.branchCtrl = new FormControl();

        this.store.select(fromCommonStore.getAuth).take(1).subscribe((auth: any) => {
            if (auth['islogin']) {
                that.usertype = auth['usertype'];
                if (auth['usertype'] != 'Super_Admin' && auth['usertype'] != 'Admin' && auth['usertype'] != 'Accounts') {
                    that.filterData.branch_id = auth['branch_id'];
                    that.branchCtrl.disable();
                }
                that.initialized = true;
                that.getReports();
            }
        });

        this.store.select(fromCommonStore.getAllBranch).subscribe((res: any) => {
            if (!_.isEmpty(res.data)) {
                that.branchList = res.data;
                that.filteredBranch = that.branchCtrl.valueChanges
                    .startWith(null)
                    .map(val => val ? that.filterBranch(val) : that.branchList.slice());
            }
        });
    }

    ngOnChanges() {
        if (this.active && this.initialized) {
            this.getReports();
        }
    }

    filterBranch(val: string) {
        return this.branchList.filter(b => b.branch_name.toLowerCase().includes(val.toLowerCase()));
    }

    displayBranchFn(branch_id: any) {
        if (!branch_id) { return ''; }
        let item = _.find(this.branchList, { 'branch_id': branch_id });
        return item ? item.branch_name : '';
    }

    onSearch() {
        this.page.offset = 0;
        this.getReports();
    }

    onReset() {
        this.filterData = {
            from_date: new Date(),
            to_date: new Date(),
            branch_id: '',
            search_name: ''
        };
        this.branchCtrl.reset();
        this.reportData = [];
        this.columns = [];
        this.page.count = 0;
    }

    pageCallback(pageInfo: any) {
        this.page.offset = pageInfo.offset !== undefined ? pageInfo.offset : (pageInfo.page - 1);
        if (!this.suppressPaging) { this.getReports(); }
    }

    onScroll() {
        this.suppressPaging = true;
        if (this.scrollTimeout) { clearTimeout(this.scrollTimeout); }
        this.scrollTimeout = setTimeout(() => { this.suppressPaging = false; }, 100);
    }

    getReports() {
        let that = this;
        let params: any = {
            page_type: 'phoneTrackingFollowupChangeReport',
            from_date: moment(this.filterData.from_date).format('YYYY-MM-DD'),
            to_date: moment(this.filterData.to_date).format('YYYY-MM-DD'),
            branch_id: this.filterData.branch_id || '',
            search_name: this.filterData.search_name || '',
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`
        };

        this.isLoadMask = this.reportsService.getReports(params).then(function (res: any) {
            that.loadingIndicator = false;
            that.reportData = res.data || [];
            that.page.count = res.totCnt || 0;
            that.columns = res.columns || [];
        }).catch(function (err: any) {
            that.loadingIndicator = false;
            that.toasterService.pop('error', 'Error', 'Failed to load report');
        });
    }

    onExcelExport() {
        let params: any = {
            page_type: 'phoneTrackingFollowupChangeReport',
            from_date: moment(this.filterData.from_date).format('YYYY-MM-DD'),
            to_date: moment(this.filterData.to_date).format('YYYY-MM-DD'),
            branch_id: this.filterData.branch_id || '',
            search_name: this.filterData.search_name || '',
            start: '0',
            limit: '99999'
        };

        this.isLoadMask = this.reportsService.getReports(params).then(function (res: any) {
            let data: any[] = res.data || [];
            let cols: any[] = res.columns || [];
            if (!data.length) { return; }
            let wb = { SheetNames: ['Report'], Sheets: {} };
            let wsData: any[][] = [];
            let headers = cols.map((c: any) => c.name);
            wsData.push(headers);
            data.forEach((row: any) => {
                let rowArr = cols.map((c: any) => row[c.prop] || '');
                wsData.push(rowArr);
            });
            let XLSX = require('xlsx');
            let ws = XLSX.utils.aoa_to_sheet(wsData);
            wb.Sheets['Report'] = ws;
            let fileName = 'UserFollowupChangeReport_' + moment().format('DD-MM-YYYY_HH-mm-ss') + '.xlsx';
            XLSX.writeFile(wb, fileName);
        });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/reports/phoneTrackingFollowupChange/phoneTrackingFollowupChange.component.ts